export enum UserType {
    INDIVIDUAL, BUSINESS, INSTITUTION
}

export const UserTypeList = [
    {
        type: UserType.INDIVIDUAL,
        name: "개인"
    },
    {
        type: UserType.BUSINESS,
        name: "사업자"
    }
];

export const AllUserTypeList = [
    ...UserTypeList, {
        type: UserType.INSTITUTION,
        name: "기관"
    }
];